var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('el-row',[_c('el-col',{attrs:{"span":24,"sm":{ offset: 8, span: 8 }}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }